/*
  Klaviyo back-in-stock — theme-owned trigger, modal, and subscribe.

  Not Klaviyo's embedded modal. On submit we POST to Klaviyo's Client
  Back-in-Stock Subscriptions API (replaces the retired onsite/components URL).
  Styling uses theme brand tokens; copy is editable under Theme settings >
  Klaviyo > Back-in-stock modal.
*/

(function () {
  'use strict';

  var BIS_SUBSCRIBE_BASE =
    'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var NEWSLETTER_SUBSCRIBE_BASE = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';
  var MODAL_ID = 'wt-klaviyo-bis-modal';
  var activeContext = null;

  function readConfig() {
    var el = document.querySelector('[data-klaviyo-bis-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('[klaviyo-bis] invalid config JSON', e);
      }
      return null;
    }
  }

  function getAtcLabel(addBtn) {
    if (!addBtn) return '';
    var labelEl =
      addBtn.querySelector('.js-atc-label-base') ||
      addBtn.querySelector(':scope > span');
    return labelEl ? labelEl.textContent.trim() : '';
  }

  function findVariantOptionsForForm(form) {
    if (!form) return null;
    var scope =
      form.closest('.wt__quick-buy--wrapper') ||
      form.closest('.wt-product') ||
      form.closest('[id^="shopify-section-"]') ||
      document;
    return scope.querySelector('variant-options');
  }

  function getVariantAvailability(variantId, form) {
    var variantOptions = findVariantOptionsForForm(form);
    var script =
      variantOptions &&
      variantOptions.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      var variants = JSON.parse(script.textContent);
      for (var i = 0; i < variants.length; i++) {
        if (Number(variants[i].id) === Number(variantId)) {
          return variants[i].available;
        }
      }
    } catch (e) {}
    return null;
  }

  function isSoldOutAtc(addBtn) {
    if (!addBtn || !addBtn.hasAttribute('disabled')) return false;

    var form =
      addBtn.closest('form[data-type="add-to-cart-form"]') ||
      addBtn.closest('form');
    var variantInput = form && form.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;

    if (variantId) {
      var available = getVariantAvailability(variantId, form);
      if (available === false) return true;
      if (available === true) return false;
    }

    var label = getAtcLabel(addBtn);
    if (!label) return false;

    var unavailable =
      (window.variantStrings && window.variantStrings.unavailable) ||
      'Unavailable';
    if (label.toLowerCase() === unavailable.toLowerCase()) return false;

    var soldOut =
      (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    var comingSoon =
      (window.variantStrings && window.variantStrings.comingSoon) ||
      'Coming soon';
    var lower = label.toLowerCase();
    var soldOutLower = soldOut.toLowerCase();
    return (
      lower === soldOutLower ||
      lower === comingSoon.toLowerCase() ||
      lower.indexOf(soldOutLower + ' -') === 0
    );
  }

  function syncBisVisibility(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a.wt-klaviyo-bis-trigger').forEach(function (trigger) {
      var form =
        trigger.closest('form[data-type="add-to-cart-form"]') ||
        trigger.closest('form');
      var addBtn = form && form.querySelector('[name="add"]');
      trigger.hidden = !isSoldOutAtc(addBtn);
    });
  }

  function getProductScope(trigger) {
    if (!trigger) return document;
    return (
      trigger.closest('.wt__quick-buy--wrapper') ||
      trigger.closest('.wt-product') ||
      trigger.closest('[id^="shopify-section-"]') ||
      document
    );
  }

  function getProductTitle(config, trigger) {
    if (config && config.productTitle) return config.productTitle;

    var scope = getProductScope(trigger);
    var titleEl =
      scope.querySelector('.wt-product__title-text') ||
      scope.querySelector('.wt-product__name a') ||
      scope.querySelector('.wt-product__name');

    return titleEl ? titleEl.textContent.trim() : '';
  }

  function stripIntroHtml(html) {
    var content =
      html ||
      'Sign up to receive a notification when this item comes back in stock.';

    return content
      .replace(
        /<span[^>]*class=['"]product-name['"][^>]*>[\s\S]*?<\/span>/gi,
        '',
      )
      .replace(/\{product_name\}/gi, '')
      .replace(/(<br\s*\/?>\s*){2,}/gi, '<br>')
      .trim();
  }

  function isMeaningfulVariantTitle(title) {
    return !!title && title !== 'Default Title';
  }

  function resolveVariantTitle(variantId, trigger) {
    var id = Number(variantId);
    var cached =
      window.__klaviyoBisVariantCache &&
      window.__klaviyoBisVariantCache[id];
    if (cached) return cached;

    var scope = getProductScope(trigger);
    var variantOptions = scope.querySelector('variant-options');
    var script =
      variantOptions &&
      variantOptions.querySelector('script[type="application/json"]');

    if (script) {
      try {
        var variants = JSON.parse(script.textContent);
        for (var i = 0; i < variants.length; i++) {
          if (Number(variants[i].id) === id) {
            return (
              variants[i].public_title ||
              variants[i].title ||
              variants[i].name ||
              ''
            );
          }
        }
      } catch (e) {}
    }

    return '';
  }

  function getContextFromTrigger(trigger) {
    var form =
      trigger.closest('form[data-type="add-to-cart-form"]') ||
      trigger.closest('form');
    if (!form) return null;

    var variantInput = form.querySelector('[name="id"]');
    var productInput = form.querySelector('[name="product-id"]');
    var variantId = variantInput && variantInput.value;
    var productId = productInput && productInput.value;

    if (!variantId) return null;

    return {
      variantId: Number(variantId),
      productId: productId ? Number(productId) : null,
      variantTitle: resolveVariantTitle(variantId, trigger),
    };
  }

  function ensureModal() {
    var existing = document.getElementById(MODAL_ID);
    if (existing) return existing;

    var root = document.createElement('div');
    root.id = MODAL_ID;
    root.className = 'wt-klaviyo-bis-modal';
    root.hidden = true;
    root.innerHTML =
      '<div class="wt-klaviyo-bis-modal__drop" data-bis-close></div>' +
      '<div class="wt-klaviyo-bis-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="wt-klaviyo-bis-title">' +
      '<button type="button" class="wt-klaviyo-bis-modal__close" data-bis-close aria-label="Close">&times;</button>' +
      '<h2 id="wt-klaviyo-bis-title" class="wt-klaviyo-bis-modal__headline"></h2>' +
      '<div class="wt-klaviyo-bis-modal__intro"></div>' +
      '<div class="wt-klaviyo-bis-modal__product" hidden>' +
      '<span class="wt-klaviyo-bis-modal__product-label">Product</span>' +
      '<span class="wt-klaviyo-bis-modal__product-value"></span>' +
      '</div>' +
      '<div class="wt-klaviyo-bis-modal__variant" hidden>' +
      '<span class="wt-klaviyo-bis-modal__variant-label">Variant</span>' +
      '<span class="wt-klaviyo-bis-modal__variant-value"></span>' +
      '</div>' +
      '<form class="wt-klaviyo-bis-modal__form" novalidate>' +
      '<label class="wt-klaviyo-bis-modal__field">' +
      '<span class="wt-klaviyo-bis-modal__field-label"></span>' +
      '<input class="wt-klaviyo-bis-modal__input" type="email" name="email" autocomplete="email" required>' +
      '</label>' +
      '<label class="wt-klaviyo-bis-modal__newsletter">' +
      '<input type="checkbox" name="newsletter" value="1" checked>' +
      '<span class="wt-klaviyo-bis-modal__newsletter-text"></span>' +
      '</label>' +
      '<button type="submit" class="wt-klaviyo-bis-modal__submit wt-button wt-button--primary wt-button--full-width"></button>' +
      '</form>' +
      '<p class="wt-klaviyo-bis-modal__message wt-klaviyo-bis-modal__message--success" hidden></p>' +
      '<p class="wt-klaviyo-bis-modal__message wt-klaviyo-bis-modal__message--error" hidden></p>' +
      '</div>';

    document.body.appendChild(root);

    root.querySelectorAll('[data-bis-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    root.querySelector('.wt-klaviyo-bis-modal__form').addEventListener(
      'submit',
      onModalSubmit,
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) closeModal();
    });

    return root;
  }

  function populateModalCopy(modal, config, trigger, context) {
    var modalConfig = (config && config.modal) || {};
    var productName = getProductTitle(config, trigger);
    var variantTitle =
      (context && context.variantTitle) ||
      resolveVariantTitle(context && context.variantId, trigger);

    modal.querySelector('.wt-klaviyo-bis-modal__headline').textContent =
      modalConfig.headline || 'Be the first to know!';
    modal.querySelector('.wt-klaviyo-bis-modal__intro').innerHTML =
      stripIntroHtml(modalConfig.body_content);

    var productRow = modal.querySelector('.wt-klaviyo-bis-modal__product');
    var productValue = modal.querySelector(
      '.wt-klaviyo-bis-modal__product-value',
    );
    if (productName) {
      productValue.textContent = productName;
      productRow.hidden = false;
    } else {
      productRow.hidden = true;
    }

    var variantRow = modal.querySelector('.wt-klaviyo-bis-modal__variant');
    var variantValue = modal.querySelector(
      '.wt-klaviyo-bis-modal__variant-value',
    );
    if (isMeaningfulVariantTitle(variantTitle)) {
      variantValue.textContent = variantTitle;
      variantRow.hidden = false;
    } else {
      variantRow.hidden = true;
    }

    modal.querySelector('.wt-klaviyo-bis-modal__field-label').textContent =
      modalConfig.email_field_label || 'Email';
    modal.querySelector('.wt-klaviyo-bis-modal__submit').textContent =
      modalConfig.button_label || 'Notify me';
    modal.querySelector('.wt-klaviyo-bis-modal__newsletter-text').textContent =
      modalConfig.newsletter_subscribe_label ||
      'Add me to your email list. Check to receive restock notifications.';
    modal.querySelector(
      '.wt-klaviyo-bis-modal__message--success',
    ).textContent =
      modalConfig.subscription_success_label ||
      "You're in! We'll let you know when it's back.";
    modal.querySelector('.wt-klaviyo-bis-modal__message--error').textContent =
      'Something went wrong. Please try again.';
  }

  function resetModalState(modal) {
    var form = modal.querySelector('.wt-klaviyo-bis-modal__form');
    form.hidden = false;
    form.reset();
    var newsletter = form.querySelector('[name="newsletter"]');
    if (newsletter) newsletter.checked = true;
    modal.querySelector('.wt-klaviyo-bis-modal__message--success').hidden = true;
    modal.querySelector('.wt-klaviyo-bis-modal__message--error').hidden = true;
    modal.querySelector('.wt-klaviyo-bis-modal__submit').disabled = false;
  }

  function openThemeModal(context, config, trigger) {
    if (!context || !context.variantId) return;

    var modal = ensureModal();
    populateModalCopy(modal, config, trigger, context);
    resetModalState(modal);
    activeContext = context;
    modal.hidden = false;
    document.documentElement.classList.add('wt-klaviyo-bis-modal-open');

    var emailInput = modal.querySelector('[name="email"]');
    if (emailInput) {
      window.requestAnimationFrame(function () {
        emailInput.focus();
      });
    }
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('wt-klaviyo-bis-modal-open');
    activeContext = null;
  }

  function shopifyCatalogVariantId(variantId) {
    return '$shopify:::$default:::' + String(variantId);
  }

  function buildBisPayload(email, variantId) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: shopifyCatalogVariantId(variantId),
            },
          },
        },
      },
    };
  }

  function klaviyoClientFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (response.status >= 200 && response.status < 300) {
        return response;
      }
      return response.text().then(function (text) {
        throw new Error('Klaviyo request failed: ' + response.status + ' ' + text);
      });
    });
  }

  function subscribeNewsletter(email, config) {
    var companyId = config && config.companyId;
    var listId = config && config.newsletterListId;
    if (!companyId || !listId) return Promise.resolve();

    var url =
      NEWSLETTER_SUBSCRIBE_BASE +
      '?company_id=' +
      encodeURIComponent(companyId);

    return klaviyoClientFetch(url, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Back in stock modal',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    });
  }

  function subscribeBackInStock(email, context, config) {
    var companyId = config && config.companyId;
    if (!companyId) {
      return Promise.reject(new Error('missing Klaviyo company id'));
    }
    if (!context || !context.variantId) {
      return Promise.reject(new Error('missing variant id'));
    }

    var url =
      BIS_SUBSCRIBE_BASE + '?company_id=' + encodeURIComponent(companyId);

    return klaviyoClientFetch(
      url,
      buildBisPayload(email, context.variantId),
    ).then(function (response) {
      if (context.subscribeNewsletter) {
        return subscribeNewsletter(email, config)
          .catch(function (err) {
            if (window.console && console.warn) {
              console.warn('[klaviyo-bis] newsletter subscribe failed', err);
            }
          })
          .then(function () {
            return response;
          });
      }
      return response;
    });
  }

  function onModalSubmit(event) {
    event.preventDefault();

    var modal = document.getElementById(MODAL_ID);
    var config = readConfig();
    var form = event.currentTarget;
    var emailInput = form.querySelector('[name="email"]');
    var email = emailInput && emailInput.value.trim();
    var newsletterInput = form.querySelector('[name="newsletter"]');

    if (!email || !activeContext) return;

    var context = {
      variantId: activeContext.variantId,
      productId: activeContext.productId,
      subscribeNewsletter: !!(newsletterInput && newsletterInput.checked),
    };

    var submitBtn = form.querySelector('.wt-klaviyo-bis-modal__submit');
    submitBtn.disabled = true;

    subscribeBackInStock(email, context, config)
      .then(function () {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          try {
            window.klaviyo.identify({ email: email });
          } catch (e) {}
        }

        form.hidden = true;
        modal.querySelector('.wt-klaviyo-bis-modal__message--error').hidden = true;
        modal.querySelector(
          '.wt-klaviyo-bis-modal__message--success',
        ).hidden = false;
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[klaviyo-bis] subscribe failed', err);
        }
        submitBtn.disabled = false;
        modal.querySelector('.wt-klaviyo-bis-modal__message--success').hidden = true;
        modal.querySelector('.wt-klaviyo-bis-modal__message--error').hidden = false;
      });
  }

  function bindTriggerClick(config) {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a.wt-klaviyo-bis-trigger');
      if (!trigger || trigger.hidden) return;

      event.preventDefault();
      event.stopPropagation();

      var context = getContextFromTrigger(trigger);
      if (!context) return;

      openThemeModal(context, config, trigger);
    });
  }

  function boot() {
    var config = readConfig();
    syncBisVisibility(document);
    bindTriggerClick(config);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var variant = payload && payload.data && payload.data.variant;
        if (variant && variant.id) {
          window.__klaviyoBisVariantCache =
            window.__klaviyoBisVariantCache || {};
          window.__klaviyoBisVariantCache[variant.id] =
            variant.public_title || variant.title || variant.name || '';
        }
        syncBisVisibility(document);
      });

      subscribe(PUB_SUB_EVENTS.quickBuyDrawerOpen, function () {
        queueMicrotask(function () {
          var root = document.querySelector('.wt__quick-buy__container');
          syncBisVisibility(root || document);
        });
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      syncBisVisibility(event.target || document);
    });
  }

  window.__klaviyoBis = {
    syncBisVisibility: syncBisVisibility,
    isSoldOutAtc: isSoldOutAtc,
    openThemeModal: openThemeModal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
